import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import { queryKeys } from '@api/queryKeys';
import type { BrandingConfig, BrandingThemeTokens } from '@shared/types';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useBrandingStore } from '@shared/hooks/useBrandingStore';

interface Props {
  children: (tokens?: BrandingThemeTokens) => React.ReactNode;
}

export function BrandingLoader({ children }: Props) {
  const setBranding = useBrandingStore((s) => s.setBranding);

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.branding,
    queryFn: () => apiClient.get<BrandingConfig>('/v1/branding'),
    staleTime: Infinity,
    retry: 1,
  });

  useEffect(() => {
    if (data) setBranding(data);
  }, [data, setBranding]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return <>{children(data?.theme)}</>;
}
